<div class="modal-content text-center">
    <div class="modal-header text-center">
        <button type="button" class="btn-close" (click)="cerrar()"></button>
    </div>
    <div class="modal-body pb-5">
        <h3 class="">Finalizar atención</h3>
        <h6>Seleccione el o los motivo(s) de la atención e indique la cantidad de operaciones para cada uno</h6>
    </div>
    <div class="modal-footer">
        <div class="row  mx-auto text-center">

            <form [formGroup]="checkboxGroup">
                <div class="row mx-auto">
                    <div class="col-7">
                        <p>Motivo de la atención</p>
                    </div>
                    <div class="col-4">
                        <p class="ml-25pc">Cantidad</p>
                    </div>
                </div>
                <div class="row col-12">
                    <div class="col-9 mx-auto">
                        <ng-container *ngFor="let checkbox of checkboxes; let i = index;" formArrayName="checkboxes">
                            <div class="form-check form-switch pt-1 mb-1">
                                <div class="col-3">
                                    <input type="checkbox" [formControlName]="i" class="form-check-input" [id]="i" />
                                </div>
                                <div class="col-9 text-start">
                                    <label class="form-check-label etiqueta" [for]="i">{{checkbox.motivo}}</label>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-3 mx-auto">
                        <ng-container *ngFor="let checkbox of checkboxes; let i = index;" formArrayName="cantidades">
                            <ng-container *ngIf="checkboxGroup.value.checkboxes[i]; else elseTemplate">
                                <div class="row">
                                    <div class="mb-1 col-6" style="padding-inline: 3px;">
                                        <input type="number" [formControlName]="i" class="cant-motivo" />
                                    </div>
                                    <div class="col-4" style="padding: 0; inline-size: fit-content;">
                                        <div *ngIf="motivoIsSubmitted">
                                            <div *ngIf="!valoresMot[i] || !validaCant[i]">
                                                <small class="text-danger" style="font-size: 0.55em;">Valor Inválido</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </ng-container>
                            <ng-template #elseTemplate>
                                <div class="row">
                                    <div class="mb-1 col-6" style="padding-inline: 3px;">
                                        <input type="text" class="cant-motivo" disabled/>
                                    </div>
                                    <div class="col-4" style="padding: 0; inline-size: fit-content;">

                                    </div>
                                </div>
                            </ng-template>

                        </ng-container>

                    </div>


                </div>
                <div *ngIf="motivoIsSubmitted && seleccion == ''">
                    <small class="text-danger">Debe seleccionar al menos un motivo de atención.</small>
                </div>
                <hr>
                <div class="col-12">
                    <p>Observaciones</p>
                </div>
                <div class="col-12 mx-auto mb-4">
                    <input type="text" class="w-75" formControlName="observaciones">
                </div>
            </form>

            <div class="row mx-auto">
                <div class="col-12 text-center">
                    <button type="button" class="btn-color" (click)="submit()">ENVIAR MOTIVOS</button>
                </div>
            </div>



            <div class="col-12 mt-4">
                <a type="button" (click)="cerrar()">Volver</a>
            </div>
        </div>
    </div>
</div>